import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from 'common/ui/button';
import { Eye, EyeOff, GripVertical } from 'lucide-react';

export function SortableItem({ id, column, onVisibilityToggle }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex gap-2 items-center justify-between p-3 bg-white border rounded-md shadow-sm hover:shadow-md transition-shadow"
    >
      <div className="flex items-center gap-3">
        {/* Drag handle */}
        <GripVertical
          {...listeners}
          {...attributes}
          className="cursor-grab text-muted-foreground hover:text-primary transition-colors"
        />
        {/* Column name */}
        <span className="font-medium text-foreground">{column.id}</span>
      </div>
      {/* Visibility toggle button */}
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onVisibilityToggle(!column.getIsVisible())}
        className="text-muted-foreground hover:text-primary transition-colors"
      >
        {column.getIsVisible() ? (
          <Eye className="h-4 w-4" />
        ) : (
          <EyeOff className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
